define('home/views/common/NotificationCardPostView',[
    'home/views/common/ActivityCardView',
    'home/mixins/withReason',
    'home/mixins/asNotificationCard',
    'home/mixins/withSubviews',

    'home/views/TruncatedPostView',
], function (
    ActivityCardView,
    withReason,
    asNotificationCard,
    withSubviews,

    TruncatedPostView
) {
    'use strict';

    var parent = ActivityCardView;

    /**
     * Abstract parent class for notification card views that show a single
     * post in the card.
     *
     * Child classes should define:
     *      - {function} getPost - fn that returns a post given an Activity of the
     *                            child-specific type (ex: ChannelPostActivity)
     *     - {function} template - fn that returns html to show for this view
     *     - {string} childClassName - the child-specific class name to be added
     *                                 to general notification card classes

     * IMPORTANT: Child classes should not define className, or they will overwrite
     *            the classes mixed into this parent. Use childClassName.
     *
     * Expects an ActivityFeedItem model. All Activity models rolled up in the
     * ActivityFeedItem model must have the same Post model as the target.
     */
    var NotificationCardPostView = parent.extend({

        /**
         * Returns the child-specific class name. This is necessary because this
         * parent class uses mixins that add notification card classes to whatever
         * is returned from this parent className function. If the child class
         * defines className it will overwrite this className and won't get the
         * mixed in values.
         *
         * @returns {string} - The class name specified by the child class.
         */
        className: function () {
            return this.childClassName;
        },

        regions: {
            postRegion: '[data-role=post]',
        },

        onRender: function () {
            this.activateRegion(this.postRegion, this.createPostView);
        },

        createPostView: function () {
            // Grouped activities should all have the same target post. Just
            // get the post from the first one.
            var post = this.getPost(this.model.activities[0]);
            return new TruncatedPostView({
                model: post,
            });
        },
    });

    var proto = NotificationCardPostView.prototype;
    withReason.call(proto);
    asNotificationCard.call(proto);
    withSubviews.call(proto);

    return NotificationCardPostView;
});

